/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon24Solid = forwardRef('CheckA2Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17.471 7.414a1.25 1.25 0 1 0-1.768-1.767l-9.562 9.562a1.131 1.131 0 0 1-1.6 0l-2.343-2.343A1.25 1.25 0 0 0 .43 14.634l2.343 2.343a3.631 3.631 0 0 0 5.136 0l9.562-9.563Z" }),
        React.createElement("path", { d: "M23.593 7.414a1.25 1.25 0 0 0-1.768-1.767L11.54 15.93a1.25 1.25 0 0 0 1.768 1.768L23.593 7.414Z" })));
});
